import {
  BillingReadinessResponse,
  BillingReadinessWindow,
} from '@chiroup/core/types/BillingReadiness.type';
import { useQuery } from 'react-query';
import billingReadinessService from '../services/billingReadiness.service';

const useBillingReadiness = (window: BillingReadinessWindow, enabled = true) =>
  useQuery<BillingReadinessResponse>(
    ['billing-readiness', window],
    () => billingReadinessService.list(window),
    { refetchOnWindowFocus: false, enabled }
  );

export default useBillingReadiness;
